// extracted by mini-css-extract-plugin
module.exports = {"backgroundImage":"styles_backgroundImage__3tlVK","text":"styles_text__ch4Vj"};